<div class="main-content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="d-sm-flex align-items-center justify-content-between mb-4 margin-bottom">
                    <h1 class="h3 mb-0 text-gray-800" style="position: absolute;top: -98px;">Activate Account</h1>
                    <div></div>
                </div>

                <div class="card shadow">
                    <div class="container-fluid">
                        <div class="container-fluid">

                            <h5>Personal Info</h5>

                            <form [formGroup]="userForm" (ngSubmit)="nextPage()" autocomplete="off">

                                <div class="row">
                                    <div class="col-md-2">
                                        <label>Email: </label>
                                    </div>
                                    <div class="col-md-10">
                                        <input class="form-control"
                                               type="email"
                                               name="email"
                                               readonly
                                               formControlName="email" />
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-2">
                                        <label>First name: </label>
                                    </div>
                                    <div class="col-md-10">
                                        <input class="form-control"
                                               type="text"
                                               name="name"
                                               #_firstname
                                               id="firstname"
                                               placeholder="First name"
                                               formControlName="firstName"
                                               (keyup)="preventSpace(_firstname.value, $event, 'firstname')"/>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-2">
                                        <label>Last name: </label>
                                    </div>
                                    <div class="col-md-10">
                                        <input class="form-control" 
                                               name="last"
                                               #_lastname
                                               id="lastname"
                                               type="text"
                                               placeholder="Last name"
                                               formControlName="lastName"
                                               (keyup)="preventSpace(_lastname.value, $event, 'lastname')"/>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-2">
                                        <label>Password: </label>
                                    </div>
                                    <div class="col-md-10">
                                        <input passwordDirective class="form-control"
                                               type="password"
                                               id="password1"
                                               #_password1
                                               placeholder="Password"
                                               autocomplete="new-password"
                                               formControlName="password1"
                                               (keyup)="preventSpace(_password2.value, $event, 'password2')" />
                                        <!--(focusout)="confirmationFail()"
                                        (focusin)="removeMessage()"-->
                                        <!--<app-password-strength [passwordToCheck]="_password1.value"
                                                               (passwordStrength)="passwordValid($event)">
                                        </app-password-strength>-->
                                        <!--<password-strength-meter [password]="_password1.value" 
                                                                 (strengthChange)="passwordValid($event)">
                                        </password-strength-meter>-->
                                        <ng9-password-strength-bar
                                            [passwordToCheck]="_password1.value"
                                            [barColors]="myColors"
                                            (onStrengthChanged)="passwordValid($event)">
                                        </ng9-password-strength-bar>
                                        <p id="passWordText" style="font-size: 12px;">
                                            Your password must be 8-20 characters long and it must contain at least one number, one capital letter and one symbol.
                                        </p>
                                    </div>
                                </div>

                                

                                <div class="row">
                                    <div class="col-md-2">
                                        <label>Confirm password: </label>
                                    </div>
                                    <div class="col-md-10">
                                        <input passwordDirective class="form-control pass2"
                                               type="password"
                                               id="password2"
                                               #_password2
                                               placeholder="Confirm password"
                                               autocomplete="new-password"
                                               formControlName="password2"
                                               (keyup)="preventSpace(_password2.value, $event, 'password2')" />
                                        <!--(focusout)="confirmationFail()"
                                        (focusin)="removeMessage()"-->
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-offset-2 col-md-10">
                                        <span id="errorPasswordMessage"></span>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-2">

                                    </div>
                                    <div class="col-md-10 text-right noPadding" style="padding: 0 15px 15px 0 !important;">
                                        <input type="submit"
                                               class="btn btn-primary"
                                               value="Finish" />
                                        <!--//[disabled]="!userForm.valid || !passwordIsValid"-->
                                    </div>
                                </div>

                            </form>

                            <!--<form name="myForm" novalidate>
                                <input type="password" class="form-control" id="password" name="password" placeholder="Enter password"
                                       [(ngModel)]="account.password" #password="ngModel"
                                       minlength="5" maxlength="50" required>
                                <ng9-password-strength-bar [passwordToCheck]="account.password"
                                                           [barLabel]="barLabel"
                                                           [barColors]="myColors">
                                </ng9-password-strength-bar>
                            </form>-->
                        </div>

                        <!-- <div class="container-fluid" [ngClass]="{'show': pageIndex == 2, 'hide': pageIndex != 2 }">

                            <h5>Security Questions</h5>

                            <div>
                                <div class="row">
                                    <div class="col-md-2">
                                        <label>Question 1: </label>
                                    </div>
                                    <div class="col-md-10">
                                        <select [(ngModel)]="securityAnswers.question1" #questions1 name="questions1" class="form-control" (change)="disableSelected(questions1.value,2)">
                                            <option value="">Please select a question</option>
                                            <option *ngFor="let question of securityQuestions" id="questions1_{{question.Id}}" value="{{question.Id}}">{{question.Text}}</option>
                                        </select>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-2">
                                        <label>Answer: </label>
                                    </div>
                                    <div class="col-md-10">
                                        <input #asnswer1 class="form-control"
                                               name="asnswer1"
                                               id="asnswer1"
                                               placeholder=""
                                               type="text"
                                               [(ngModel)]="securityAnswers.answer1"
                                               (keypress)="preventSpace(asnswer1.value, $event, 'asnswer1')"
                                               (keyup)="preventSpace(asnswer1.value, $event, 'asnswer1')" />
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-2">
                                        <label>Question 2: </label>
                                    </div>
                                    <div class="col-md-10">
                                        <select [(ngModel)]="securityAnswers.question2" #questions2 name="questions2" class="form-control" (change)="disableSelected(questions2.value,1)">
                                            <option value="">Please select a question</option>
                                            <option *ngFor="let question of securityQuestions" id="questions2_{{question.Id}}" value="{{question.Id}}">{{question.Text}}</option>
                                        </select>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-2">
                                        <label>Answer: </label>
                                    </div>
                                    <div class="col-md-10">
                                        <input #asnswer2
                                               class="form-control"
                                               name="answer2"
                                               id="answer2"
                                               placeholder=""
                                               type="text"
                                               [(ngModel)]="securityAnswers.answer2"
                                               (keypress)="preventSpace(asnswer2.value, $event, 'asnswer2')"
                                               (keyup)="preventSpace(asnswer2.value, $event, 'asnswer2')" />
                                    </div>
                                </div>

                                <br />

                                <div class="row">
                                    <div class="col-md-2">

                                    </div>
                                    <div class="col-md-10 text-right noPadding" style="padding: 0 15px 15px 0 !important;">
                                        <input type="button"
                                               class="btn btn-primary"
                                               value="Previous"
                                               (click)="prevPage()" />
                                        <input type="button"
                                               class="btn btn-primary"
                                               value="Finish"
                                               (click)="validateForm()" />
                                    </div>
                                </div>
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>








